var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPowerTabCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    opacity: 0.2,
    cx: 7,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.828 4.172a.5.5 0 010 .707l-2.122 2.12 2.122 2.122a.5.5 0 11-.707.707L7 7.706 4.88 9.828a.5.5 0 11-.707-.707L6.292 7l-2.12-2.12a.5.5 0 01.707-.707l2.12 2.12 2.122-2.12a.5.5 0 01.707 0z",
    fill: "#07F89C"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerTabCloseIcon);
export default __webpack_public_path__ + "static/assets/power-tab-close-icon.b4a02f58.svg";
export { ForwardRef as ReactComponent };